import { injectable } from '@wix/typesafe-inversify';
import { fetchWidgetsStageData } from '@wix/bob-widget-services';
import type { BlocksAppData } from '@wix/document-services-types';
import type { IBobWidgetManifestFetcher } from './IBobWidgetManifestFetcher';
import { monitored } from '../Monitoring/monitored';

@injectable()
export class BobWidgetManifestFetcher implements IBobWidgetManifestFetcher {
  @monitored('get-manifest-stage-data')
  getWidgetsStageData(
    appDefinitionId: string,
    appFields: BlocksAppData['appFields'],
    components: BlocksAppData['components'],
  ) {
    return fetchWidgetsStageData({
      appDefinitionId,
      appFields,
      components,
    } as any);
  }
}
